import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'


import PropTypes from 'prop-types';

import uuidv4 from 'uuid';
import update from 'immutability-helper';


import ArticuloDesc from './articulo_desc';
import NeuriteGrid from '../../components/neurite_grid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import CircularProgress from '@material-ui/core/CircularProgress';

//actions:
import { navigate, openDialog } from '../../actions';

import { getData, deleteData } from '../../dataLib';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        // flexGrow: 1,
        width: 750
    },
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formRight: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formSelect: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
    grid: {
        // padding: '0 12px',
        width: '100%',
    },
    buttonAtras: {
        margin: '0 0 10px 16px',
        height: 40,
        width: 123,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    centroSelect: {
        maxWidth: 240
    },
    modeloSelect: {
        marginRight: 20,
        maxWidth: 240
    },
    buttonIcon: {
        marginLeft: theme.spacing(2),
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    inputElementLeft: {
        textAlign: "start",
        cursor: "auto"
    }
});

class ArticuloEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            articuloCompraCentroId: -1,
            detalles: {},
            isLoading: true,
            historico: [],
        };
    };

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }
        this.getArticuloDetalles(parseInt(this.props.match.params.id));
    };

    getArticuloDetalles = (articulo_compra_centro_id) => {

        getData(
            'ArticuloCompraCtl/detalles/' + articulo_compra_centro_id,
            (response) => {

                // corrige los centros para que solo figure la descripción y en
                // el caso de los pedidos el precio de la línea (porque la grid no
                // permite mezclar campos anidados)
                response.data.articuloCompraCentro.forEach(p => p.centro = p.centro.descr);
                response.data.dcPedidoLinea.forEach(p => {
                    p.fDoc = p.pedido.fDoc;
                    p.centro = p.pedido.centro.descr;
                    p.proveedor = p.pedido.proveedorDescr;
                    p.documento = p.pedido.refPedido;
                });

                this.setState({
                    ...this.state,
                    detalles: response.data,
                    articuloCompraCentroId: articulo_compra_centro_id,
                    isLoading: false
                })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching detalles ArticuloCompraCtl'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    getHistorico = () => {

        this.setState({ ...this.state, isLoading: true });
        getData(
            'ArticuloCompraCtl/historico/' + this.state.articuloCompraCentroId,
            (response) => {
                this.setState({
                    ...this.state,
                    historico: response.data,
                    isLoading: false
                })
            },
            () => {
                this.setState({ ...this.state, isLoading: false });
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching histórico ArticuloCompraCtl'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };


    goBack = () => {
        this.props.navigate("mae_redemption_articulo");
    }

    newCodigoBarras = () => {
        this.props.openDialog('EditCodigoBarras', {
            okHandler: (nuevoCodigo) => {
                //add                
                const newCodigos = [...this.state.detalles.articuloCompraCodBarras, nuevoCodigo];
                const detalles = { ...this.state.detalles, articuloCompraCodBarras: newCodigos };
                this.setState({ ...this.state, detalles: detalles });

                this.props.openDialog('SimpleMessage', {
                    message: 'Código de barras añadido'
                }, 'post_ok_codBarras', false, 'sm');

            },
            openDialog: this.props.openDialog,
            codigo: { articuloCompraId: this.state.detalles.id },
            user: this.props.user
        }, 'new_codigo_barras');
    };

    handleDeleteCodigoDeBarras = codigo => {

        this.props.openDialog(
            'ConfirmationDialog',
            {
                message: '¿Desea borrar el código de barras ' + codigo.codBarras + ' para este artículo?',
                acceptHandler: () => {
                    const url = 'ArticuloCompraCodBarras/' + codigo.id;
                    deleteData(url, () => {
                        const newCodigos = this.state.detalles.articuloCompraCodBarras.filter(c => c.id !== codigo.id)
                        const detalles = { ...this.state.detalles, articuloCompraCodBarras: newCodigos }
                        this.setState({ ...this.state, detalles: detalles });
                    },
                        (error) => {
                            this.props.openDialog('SimpleMessage', {
                                message: 'error borrando codigo de barras'
                            }, 'error_delete_codBarras', false, 'sm');
                        },
                        this.props.user);
                }
            },
            'borrar_codigo_barras',
            false,
            'sm',
        );

    };

    openEditCodigo = codigo => {
        this.props.openDialog('EditCodigoBarras', {
            okHandler: (nuevoCodigo) => {
                //modify
                const newCodigos = this.state.detalles.articuloCompraCodBarras.map(c => {
                    if (c.id === codigo.id) return nuevoCodigo;
                    else return c;
                });
                const detalles = { ...this.state.detalles, articuloCompraCodBarras: newCodigos }
                this.setState({ ...this.state, detalles: detalles });

                this.props.openDialog('SimpleMessage', {
                    message: 'Código de barras modificado'
                }, 'put_ok_codBarras', false, 'sm');


            },
            openDialog: this.props.openDialog,
            codigo: codigo,
            user: this.props.user
        }, 'edit_codigo_barras');
    }

    render() {

        const { classes } = this.props;
        let tickets = 0, ticketsSugeridos = 0, stock = 0, bActivo = true;

        const height_header = 40, height_row = 35;

        if (!this.state.isLoading && this.state.detalles && this.state.detalles.articuloCompraCentro) {
            let ac = this.state.detalles.articuloCompraCentro.find(c => c.id === this.state.articuloCompraCentroId);
            tickets = ac.puntos;
            ticketsSugeridos = Math.round(parseFloat(this.state.detalles.ultPrecio) * 60.5);
            stock = ac.stock;
            bActivo = ac.activo;
            /* if (this.state.detalles.dcPedidoLinea && this.state.detalles.dcPedidoLinea.length > 0) {
                ultFechaCompra = new Date(this.state.detalles.dcPedidoLinea[0].pedido.fDoc).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
            } */
        }

        let columnsStocks=[
            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 150},
            { key: 'activo', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 55 },
            { key: 'puntos', name: 'Puntos', type: 'int', editable: false, dragable: false, width: 55 },
            { key: 'stock', name: 'Stock', type: 'int', editable: false, dragable: false, width: 55 },
            { key: 'precioMedio', name: 'Precio Medio', type: 'float', editable: false, dragable: false, width: 65 },
            { key: 'bStockTienda', name: 'Tienda', type: 'bool', editable: false, dragable: false, width: 55 },
            { key: 'bStockAlmacen', name: 'Almacen', type: 'bool', editable: false, dragable: false, width: 55 },
            { key: 'bStockMaquina', name: 'Máquina', type: 'bool', editable: false, dragable: false, width: 55 },
            { key: 'fAlta', name: 'Fecha alta', type: 'date', editable: false, dragable: false, width: 80 },
            { key: 'fBaja', name: 'Fecha baja', type: 'date', editable: false, dragable: false, width: 80 },
        ];
        if ( this.props.kd ) columnsStocks.splice(0,1);

        let columnsHistoricoCompras=[
            { key: 'fDoc', name: 'Fecha', type: 'date', editable: false, dragable: false, width: 80 },
            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 150 },
            { key: 'proveedor', name: 'Proveedor', editable: false, dragable: false, width: 250 },
            { key: 'documento', name: 'Documento', editable: false, dragable: false, width: 100 },
            { key: 'cantidad', name: 'Unidades', type: 'int', editable: false, dragable: false, width: 55 },
            { key: 'precio', name: 'Precio Compra', type: 'float', editable: false, dragable: false, width: 65 },
        ];
        if ( this.props.kd ) columnsHistoricoCompras.splice(1,1);

        let columnsHistoricoMovimientos=[
            { key: 'fecha', name: 'Fecha', type: 'date', editable: false, dragable: false, width: 80 },
            { key: 'movimiento', name: 'Movimiento', editable: false, dragable: false, width: 150 },
            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 150 },
            { key: 'cli_Prov', name: 'Cliente/Proveedor', editable: false, dragable: false, width: 250 },
            { key: 'unidades', name: 'Unidades', type: 'float', editable: false, dragable: false, width: 55 },
        ];
        if ( this.props.kd ) columnsHistoricoMovimientos.splice(2,1);



        return (
            <div className={classes.root}>
                {!this.state.isLoading && this.state.detalles ?
                    <div>
                        <div className={classes.toolbar} />
                        <div>
                            <FormControl>
                                <IconButton
                                    className={classes.buttonIcon}
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.goBack}
                                >
                                    {' '}
                                    <Icon>keyboard_backspace</Icon>
                                </IconButton>
                            </FormControl>
                        </div>
                        <div style={{ marginBottom: 20 }}>

                            <ArticuloDesc articulo={this.state.detalles} tickets={tickets} ticketsSugeridos={ticketsSugeridos} stock={stock} isActivo={bActivo}></ArticuloDesc>

                            <div className={classes.containerPair}>
                                <div className={classes.grid}>
                                    <NeuriteGrid
                                        id="a_e_1"
                                        columns={[
                                            { key: 'codBarras', name: 'Código de barras', editable: false, dragable: false, width: 200 },
                                        ]}
                                        rows={this.state.detalles.articuloCompraCodBarras}
                                        buttonEdit={true}
                                        buttonDelete={true}
                                        buttonNew={true}
                                        enableFilter={false}
                                        onNewRowClick={this.newCodigoBarras}
                                        onDeleteClick={this.handleDeleteCodigoDeBarras}
                                        onEditClick={this.openEditCodigo}

                                    />
                                </div>
                                <TextField
                                    id="outlined-read-only-input-cod"
                                    label="Cód. CC"
                                    style={{ marginRight: "20px" }}
                                    defaultValue={this.state.detalles.cod}
                                    InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                                    variant="outlined"
                                />
                            </div>
                            <div className={classes.grid}>
                                <Typography variant="body1" className={classes.title} color={'primary'}>Stocks</Typography>
                                <NeuriteGrid
                                    id="a_e_2"
                                    columns={columnsStocks}
                                    rows={this.state.detalles.articuloCompraCentro}
                                    buttonEdit={false}
                                    buttonDelete={false}
                                    buttonNew={false}
                                    enableFilter={false}
                                    height={Math.min(300, height_header + this.state.detalles.articuloCompraCentro.length * height_row)}
                                />
                            </div>
                            <div className={classes.grid}>
                                <Typography variant="body1" className={classes.title} color={'primary'}>Histórico de compras</Typography>
                                <NeuriteGrid
                                    id="a_e_3"
                                    columns={columnsHistoricoCompras}
                                    rows={this.state.detalles.dcPedidoLinea}
                                    buttonEdit={false}
                                    buttonDelete={false}
                                    buttonNew={false}
                                    enableFilter={false}
                                    height={Math.min(300, height_header + this.state.detalles.dcPedidoLinea.length * height_row)}
                                />
                            </div>
                            <div className={classes.grid}>
                                <Typography variant="body1" className={classes.title} color={'primary'}>Histórico movimientos</Typography>
                                <NeuriteGrid
                                    id="a_e_4"
                                    columns={columnsHistoricoMovimientos}
                                    rows={this.state.historico}
                                    buttonEdit={false}
                                    buttonDelete={false}
                                    buttonNew={false}
                                    enableFilter={false}
                                    height={Math.min(300, height_header + this.state.historico.length * height_row)}
                                />
                                <Button className={classes.buttonsBottom} variant="contained" color="primary"
                                    onClick={() => {
                                        this.getHistorico();
                                    }}>Carga Movimientos
                                </Button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                }
            </div>
        );
    };

};

ArticuloEdit.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        kd : state.userProfile.kd,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        openDialog
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(ArticuloEdit)));
